const entries = Object.entries({
  '0500': 'DE',
  '0600': 'FR',
  '5000': 'AT',
  '5900': 'NL',
  '6000': 'BE',
  '6100': 'LU',
  '6200': 'CH',
  '6600': 'DK',
  '6800': 'GB',
  '7100': 'ES',
  '7300': 'IT',
  '7400': 'RS',
  '7500': 'SI',
  '7600': 'HR',
  '7700': 'RO',
  '7800': 'BG',
  '7900': 'SK',
  '8000': 'TR',
  '8100': 'US',
  '8700': 'LT',
  '8800': 'FI',
  '8900': 'LV',
  '9000': 'RU',
  '9200': 'UA',
  '9300': 'HK',
  '9500': 'PL',
  '9600': 'SE',
  '9700': 'CZ',
  '9800': 'HU',
  '9900': 'CA',
});

const entriesReverse: [string, string][] = entries.map(([key, value]) => [value, key]);

export const salesorgCountry = new Map<string, string>(entries);

export const salesorgCountryReverse = new Map<string, string>(entriesReverse);

export const salesOrgToCountry = (salesOrg: string): string => {
  return (salesorgCountry.get(salesOrg) ?? 'DE').toLowerCase();
};

export const countryToSalesOrg = (country: string): string => {
  return salesorgCountryReverse.get(country.toUpperCase()) ?? '0500';
};
